const OrderRoutes = {
  getAllOrders: "/orders/all",
  quoteOrders: "/orders/quote",
}

export default OrderRoutes